var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5265 0.631579C39.5265 0.282768 39.2438 0 38.895 0H1.00023L0.926576 0.00424909C0.612467 0.0407323 0.368652 0.307683 0.368652 0.631579C0.368652 0.98039 0.65142 1.26316 1.00023 1.26316H38.895L38.9686 1.25891C39.2827 1.22243 39.5265 0.955475 39.5265 0.631579ZM24.3687 12C24.3687 11.6512 24.0859 11.3684 23.7371 11.3684H1.00023L0.926576 11.3727C0.612467 11.4092 0.368652 11.6761 0.368652 12C0.368652 12.3488 0.65142 12.6316 1.00023 12.6316H23.7371L23.8107 12.6273C24.1248 12.5908 24.3687 12.3239 24.3687 12Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.895 22.7368C39.2438 22.7368 39.5265 23.0196 39.5265 23.3684C39.5265 23.6923 39.2827 23.9592 38.9686 23.9957L38.895 24H1.00023C0.65142 24 0.368652 23.7172 0.368652 23.3684C0.368652 23.0445 0.612467 22.7775 0.926576 22.7411L1.00023 22.7368H38.895Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.4ef0879bd9cf5515ace0a5c51ce3db7e.svg";
export { ForwardRef as ReactComponent };